import { TCalendarTypeValue, ICalendarType } from '../types/calendarTypes';

export const AddingCalendarTypes : ICalendarType[] = [
  {
    value: 'WORK',
    string: 'Рабочий',
  },
  {
    value: 'PERSONAL',
    string: 'Личный',
  },
];

export const getCalendarTypeByValue = (value: TCalendarTypeValue) => {
  return AddingCalendarTypes.find((elem) => elem.value === value);
};
